/**
 * Dashboard 概览自动刷新 Hook
 * 在登录后自动拉取 /dashboard/overview，并每隔 10 秒刷新一次
 */

import { useEffect } from 'react';
import { useDashboardStore } from '@/stores/modules/dashboard';
import { useIsAuthenticated, useUserInfo } from '@/stores/modules/auth';

/**
 * Dashboard 概览自动刷新 Hook
 *
 * - 登录后立即拉取一次 USDT 余额 / 当月积分 / 当前订阅
 * - 每隔 10 秒自动刷新一次
 * - 在登录页或未登录时不执行
 *
 * @example
 * ```ts
 * function AppLayout() {
 *   useAutoRefreshOverview();
 *   return <Layout />;
 * }
 * ```
 */
export const useAutoRefreshOverview = () => {
  const isAuthenticated = useIsAuthenticated();
  const userInfo = useUserInfo();
  const { refreshOverview } = useDashboardStore();

  useEffect(() => {
    if (
      !isAuthenticated ||
      !userInfo?.userId ||
      window.location.pathname === '/login'
    ) {
      return;
    }

    const timer = setTimeout(() => {
      refreshOverview();
    }, 100);

    const intervalId = setInterval(() => {
      if (isAuthenticated && window.location.pathname !== '/login') {
        refreshOverview();
      }
    }, 10000);

    return () => {
      clearTimeout(timer);
      clearInterval(intervalId);
    };
  }, [isAuthenticated, userInfo?.userId, refreshOverview]);
};
